import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faAward, faCalendarAlt, faClock, faPaperPlane } from '@fortawesome/free-solid-svg-icons';

import { SIGNUP_FORM_URL } from '../../../../config/links';
import { Reveal } from '../../../../components/Reveal/Reveal';
import { StyledQr } from '../../../../components/StyledQr/StyledQr';

import ui from '../../../../styles/ui.module.css';
import st from './Signup.module.css';

export function Signup() {
  return (
    <section className={`${ui.section} ${st.root}`}>
      <div className={ui.container}>
        <div className={st.cta}>
          <Reveal>
            <div className={st.copy}>
              <div className={ui.kicker}>Запись</div>
              <h2 className={ui.h2}>Готовы присоединиться к программе?</h2>
              <p className={ui.p}>
                Откройте форму регистрации по кнопке или отсканируйте QR-код — удобно, если вы смотрите лендинг с компьютера.
              </p>
              {/*<div className={st.miniRow}>*/}
              {/*  <div className={st.mini}>*/}
              {/*    <FontAwesomeIcon icon={faClock} /> 2 месяца*/}
              {/*  </div>*/}
              {/*  <div className={st.mini}>*/}
              {/*    <FontAwesomeIcon icon={faCalendarAlt} /> 2 раза в неделю*/}
              {/*  </div>*/}
              {/*  <div className={st.mini}>*/}
              {/*    <FontAwesomeIcon icon={faAward} /> удостоверение*/}
              {/*  </div>*/}
              {/*</div>*/}
            </div>
          </Reveal>

          <Reveal delay={0.05}>
            <div className={`${ui.card} ${st.card}`}>
              <div className={st.cardTitle}>
                <FontAwesomeIcon icon={faPaperPlane} /> Быстрая заявка
              </div>
              <div className={st.form}>
                <a
                  className={`${ui.btn} ${ui.btnFull}`}
                  href={SIGNUP_FORM_URL}
                  target="_blank"
                  rel="noreferrer"
                >
                  Записаться <FontAwesomeIcon icon={faArrowRight} />
                </a>

                <div className={st.qrRow}>
                  <a className={st.qrLink} href={SIGNUP_FORM_URL} target="_blank" rel="noreferrer" aria-label="Открыть форму по QR-коду">
                    <StyledQr url={SIGNUP_FORM_URL} size={190} />
                  </a>
                  <div className={st.qrCopy}>
                    <div className={st.qrTitle}>QR для телефона</div>
                    <div className={st.fineprint}>
                      Откройте камеру и наведите на код — ссылка на форму откроется автоматически.
                    </div>
                  </div>
                </div>
                <div className={st.fineprint}>
                  Нажимая «Записаться», вы переходите к форме регистрации на сервисе Яндекса.
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

